import { render, staticRenderFns } from "./SyntheticSchedule.vue?vue&type=template&id=5bebea8b&scoped=true"
import script from "./SyntheticSchedule.vue?vue&type=script&lang=js"
export * from "./SyntheticSchedule.vue?vue&type=script&lang=js"
import style0 from "./SyntheticSchedule.vue?vue&type=style&index=0&id=5bebea8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebea8b",
  null
  
)

export default component.exports